/**
 * WORK-ORDER-TASK-SELECTOR.JSX - Task Selection Component for Work Order
 * 
 * SUMMARY:
 * Presentational component that renders the task selection dropdown and manage items button.
 * Allows users to select tasks from the dropdown and manage individual subcontractor items.
 * 
 * PROPS:
 * @param {Array} selectedTasks - Currently selected tasks
 * @param {Array} allTasks - All available tasks for dropdown
 * @param {Function} handleTaskChange - Handler for task selection changes
 * @param {Function} handleOpenModal - Handler for opening manage items modal
 */

import React from 'react';
import Button from 'react-bootstrap/Button';
import HandymanIcon from '@mui/icons-material/Handyman';
import { formatTasksForDisplay } from '../utils/work-order-helpers';
import TaskMultiSelect from 'src/components/inputs/task-multi-select';

/**
 * Work Order task selector component.
 * 
 * @component
 * @example
 * <WorkOrderTaskSelector
 *   selectedTasks={selectedTasks}
 *   allTasks={allTasks}
 *   handleTaskChange={handleChange}
 *   handleOpenModal={openModal}
 * />
 */
const WorkOrderTaskSelector = ({
  selectedTasks,
  allTasks,
  handleTaskChange,
  handleOpenModal
}) => {
  return (
    <div className="row mt-4">
      <div className="col-12" data-cy="taskSelector">
        <div className="d-flex align-items-end gap-3">
          <div style={{ flex: 1 }}>
            <TaskMultiSelect
              filterVariationsByStatus={true}

              value={formatTasksForDisplay(selectedTasks)}
              items={allTasks}
              placeholder="Select Task"
              isMulti
              onChangeHandler={handleTaskChange}
              isSearchable={true}
              dropdownWidth='100%'
              contractorWorkIcon={HandymanIcon}
              name="taskSelector"
            />
          </div>
          <div>
            <Button
              variant="primary"
              className="wo-btn-primary"
              onClick={handleOpenModal}
              disabled={selectedTasks.length === 0}
              data-cy="manage-items-button"
            >
              Manage Items
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderTaskSelector;
